import {call, put, take} from 'redux-saga/effects';

import UserAttributesApi from 'static/three-oh/src/modules/apis/UserAttributes';

import * as actions from '../actions/userAttributesActions';
import * as types from '../constants/userAttributesActionTypes';

export function * getUserAttributes() {
  try {
    const response = yield call(UserAttributesApi.get);
    yield put(actions.loadUserAttributesSuccess(response.data));
  } catch (error) {
    yield put(actions.loadUserAttributesFailure(error));
  }
}

export function * watchGetUserAttributes() {
  yield take(types.USER_ATTRIBUTES_LOAD_REQUEST);
  yield call(getUserAttributes);
}
